import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { SiteConfigurationService } from './siteConfigurationService'
import { ServiceProviderSymbol } from '@wix/thunderbolt-symbols'

export const site: ContainerModuleLoader = (bind) => {
	bind(ServiceProviderSymbol).to(SiteConfigurationService)
}

export const editor = site
